module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('nav', {
    staticClass: "navigation-desktop",
    class: {
      "navigation-desktop--scrolled": _vm.$store.state.nav >= 1 || _vm.$route.path.includes("/contact"), "navigation-desktop--alt": _vm.$route.meta === "alt", "navigation-desktop--contact": _vm.$route.path.includes("/contact")
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__background"
  }, [_c('div', {
    staticClass: "navigation-desktop__container"
  }, [_c('div', {
    staticClass: "navigation-desktop__right"
  }, [_c('a', {
    staticClass: "navigation-desktop__phone-button",
    attrs: {
      "href": _vm.props.acf.nav.phone_href
    }
  }, [_c('Icon', {
    staticClass: "navigation-desktop__phone-icon",
    attrs: {
      "name": "phone"
    }
  }), _c('div', {
    staticClass: "navigation-desktop__phone-number",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.nav.phone_number)
    }
  })], 1), _c('div', {
    staticClass: "navigation-desktop__links",
    on: {
      "mouseenter": _vm.dropdownActive,
      "mouseleave": _vm.dropdownLeave
    }
  }, [_vm._l((_vm.links), function(link, i) {
    return (link.navigation === "left") ? _c('div', {
      key: i,
      ref: "root",
      refInFor: true,
      staticClass: "navigation-desktop__link",
      class: {
        "navigation-desktop__link--active": _vm.$route.name === link.name
      },
      attrs: {
        "to": link.path
      },
      on: {
        "mouseover": function($event) {
          _vm.hoverDropdown(i, link)
        },
        "click": function($event) {
          _vm.pageLink(link)
        }
      }
    }, [_vm._v(_vm._s(link.name))]) : _vm._e()
  }), _c('div', {
    staticClass: "navigation-desktop__dropdown-arrow",
    class: {
      active: _vm.dropdownShow, open: _vm.dropdownSmooth
    },
    style: ({
      left: _vm.left
    })
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownSide === "left"),
      expression: "dropdownSide === \"left\""
    }],
    staticClass: "navigation-desktop__dropdown",
    class: {
      active: _vm.dropdownShow, open: _vm.dropdownSmooth
    },
    style: ({
      left: _vm.left,
      height: _vm.height
    })
  }, [_c('transition-group', {
    attrs: {
      "name": "navigation-desktop__dropdown--slide",
      "tag": "div"
    }
  }, _vm._l((_vm.links), function(link, i) {
    return (link.navigation === "left") ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showing === i),
        expression: "showing === i"
      }],
      key: i,
      ref: "link",
      refInFor: true,
      staticClass: "navigation-desktop__dropdown--container"
    }, _vm._l((link.children), function(item, j) {
      return _c('router-link', {
        key: j,
        staticClass: "navigation-desktop__dropdown--content",
        attrs: {
          "to": item.path
        }
      }, [_c('Icon', {
        staticClass: "navigation-desktop__dropdown--content-icon",
        attrs: {
          "name": item.icon
        }
      }), _c('div', {
        staticClass: "navigation-desktop__dropdown--content-text",
        domProps: {
          "innerHTML": _vm._s(item.name)
        }
      })], 1)
    })) : _vm._e()
  }))], 1)], 2)]), _c('router-link', {
    staticClass: "navigation-desktop__logo",
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "SimpleLogo"
    }
  })], 1), _c('div', {
    staticClass: "navigation-desktop__right"
  }, [_c('div', {
    staticClass: "navigation-desktop__links",
    on: {
      "mouseenter": _vm.dropdownActive,
      "mouseleave": _vm.dropdownLeave
    }
  }, [_vm._l((_vm.links), function(link, i) {
    return (link.navigation === "right" && link.path !== "/contact") ? _c('div', {
      key: i,
      ref: "root",
      refInFor: true,
      staticClass: "navigation-desktop__link",
      class: {
        "navigation-desktop__link--active": _vm.$route.name === link.name
      },
      attrs: {
        "to": link.path
      },
      on: {
        "mouseover": function($event) {
          _vm.hoverDropdown(i, link)
        },
        "click": function($event) {
          _vm.pageLink(link)
        }
      }
    }, [_vm._v(_vm._s(link.name))]) : _vm._e()
  }), _c('div', {
    staticClass: "navigation-desktop__dropdown-arrow",
    class: {
      active: _vm.dropdownShow, open: _vm.dropdownSmooth
    },
    style: ({
      left: _vm.left
    })
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownSide === "right"),
      expression: "dropdownSide === \"right\""
    }],
    staticClass: "navigation-desktop__dropdown",
    class: {
      active: _vm.dropdownShow, open: _vm.dropdownSmooth
    },
    style: ({
      left: _vm.left,
      height: _vm.height
    })
  }, [_c('transition-group', {
    attrs: {
      "name": "navigation-desktop__dropdown--slide",
      "tag": "div"
    }
  }, _vm._l((_vm.links), function(link, i) {
    return (link.navigation === "right") ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showing === i),
        expression: "showing === i"
      }],
      key: i,
      ref: "link",
      refInFor: true,
      staticClass: "navigation-desktop__dropdown--container"
    }, _vm._l((link.children), function(item, j) {
      return _c('router-link', {
        key: j,
        staticClass: "navigation-desktop__dropdown--content",
        attrs: {
          "to": item.path
        }
      }, [_c('Icon', {
        staticClass: "navigation-desktop__dropdown--content-icon",
        attrs: {
          "name": item.icon
        }
      }), _c('div', {
        staticClass: "navigation-desktop__dropdown--content-text",
        domProps: {
          "innerHTML": _vm._s(item.name)
        }
      })], 1)
    })) : _vm._e()
  }))], 1)], 2), _c('router-link', {
    staticClass: "navigation-desktop__appointment-button",
    attrs: {
      "to": "/contact#form"
    }
  }, [_vm._v("Book Online")])], 1)], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8d3df6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-desktop/navigation-desktop.pug
// module id = 643
// module chunks = 1